import Decimal from 'decimal.js';

import { TypeaheadSelectInputOption } from '@/components/form/baseInputs/inputTypes';
import { PathsOf } from '@/types/subform';

import { CommonHypotheticalTransferFormShape } from '../EstateWaterfallHypotheticalTransfers/estateWaterfallHypotheticalTransfers.types';

export enum HypotheticalCharitableTrustModalKind {
  CRT = 'CRT',
  CLT = 'CLT',
}

export interface HypotheticalCharitableTrustFormShape
  extends CommonHypotheticalTransferFormShape {
  hypotheticalWaterfallId: string;
  simulatedProposalId: string;
  sourceId: string;
}

export type HypotheticalCharitableTrustFormPaths =
  PathsOf<HypotheticalCharitableTrustFormShape>;

export interface EstateWaterfallHypotheticalCharitableTrustModalContextType {
  waterfallId: string;
  hypotheticalCharitableTrustId: string | null;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
  initialSourceId?: string;
  proposalOptions: TypeaheadSelectInputOption<string>[];
  setProposalOptions: (options: TypeaheadSelectInputOption<string>[]) => void;
  sourceEntityOptions: TypeaheadSelectInputOption<string>[];
  setSourceEntityOptions: (
    options: TypeaheadSelectInputOption<string>[]
  ) => void;
  sourceIndividualOptions: TypeaheadSelectInputOption<string>[];
  setSourceIndividualOptions: (
    options: TypeaheadSelectInputOption<string>[]
  ) => void;
  sourceValues: Record<string, SourceValues>;
  setSourceValues: (values: Record<string, SourceValues>) => void;
  fundingId: string;
  setFundingId: (id: string) => void;
  charitableTrustModalKind: HypotheticalCharitableTrustModalKind;
}

export type EntityOrClientProfileId = string;
export interface SourceValues {
  totalValue: Decimal;
  byClassId: Record<
    string,
    {
      displayName: string;
      totalValueForClass: Decimal;
      hasOwnershipStake: boolean | null;
      ownershipPercentage: Decimal | null;
    }
  >;
}
